import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';
import './Login.css';

function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await api.post('/api/auth/login', { email, password });
      const user = res.data.user;

      // Only allow admins
      if (user.role !== 'admin') {
        // Clear any saved token just in case
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setError('Access denied. This portal is for administrators only.');
        return;
      }

      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(user));
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    }
  };

  return (
    <div className="login-page">
      <div className="login-bg-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>

      <div className="login-container">
        {/* Left Branding Panel */}
        <div className="login-brand">
          <div className="brand-lock">🔐</div>
          <h1>Admin Portal</h1>
          <p className="brand-tagline">Secure administration dashboard</p>
        </div>

        {/* Right Form Panel */}
        <div className="login-form-panel">
          <div className="form-header">
            <h2>Admin Access</h2>
            <p>Enter your credentials to manage the vault</p>
          </div>

          {error && <div className="login-error">{error}</div>}

          <form onSubmit={handleSubmit} className="login-form">
            <div className="input-group">
              <span className="input-icon">📧</span>
              <input type="email" placeholder="Email address" value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="input-group">
              <span className="input-icon">🔒</span>
              <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="login-btn">
              <span>Enter Admin Panel</span>
              <span className="btn-arrow">→</span>
            </button>
          </form>

          <p className="switch-link" style={{ marginTop: '1rem', textAlign: 'center', color: '#94a3b8' }}>
            <Link to="/login">Back to User Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
